export const host = process.env.REACT_APP_API_HOST ?? 'https://api.fxbet.co';
